import {
  Table,
  TableColumn,
  useDateFormat,
  useTimeFormat,
} from '@revolut-internal/ui-kit'

import { UserCell } from 'components/UserCell'
import { AssistantDialogueEnty } from 'lib/apiClient'

export const defineAssistantConversationsTableColumns =
  (): TableColumn<AssistantDialogueEnty>[] => {
    return [
      {
        Header: 'User',
        accessor: 'owner',
        width: '214',
        disableSortBy: true,
        disableResizing: true,
        Cell: ({ value }) => {
          return (
            <UserCell
              firstName={value?.firstName ?? 'Unknown'}
              lastName={value?.lastName ?? 'User'}
              id={value?.id ?? ''}
            />
          )
        },
      },
      {
        Header: 'Messages',
        accessor: 'messageCount',
        width: '182',
        disableSortBy: true,
        disableResizing: true,
      },
      {
        Header: 'Last activity',
        accessor: 'lastInteraction',
        width: '182',
        disableResizing: true,
        Cell: ({ value }) => {
          const dateFormat = useDateFormat()
          const timeFormat = useTimeFormat({
            style: 'precise',
          })
          const date = new Date(value)
          return <Table.Cell>{`${dateFormat(date)}, ${timeFormat(date)}`}</Table.Cell>
        },
      },
    ]
  }
